import { clsx } from 'clsx';

import type { ISegmentedControlOption, ISegmentedControlProps } from './interfaces/ISegmentedControl';

import styles from './scss/SegmentedControl.module.scss';

function SegmentedControl({
  options,
  value,
  onChange,
  fullWidth,
  className,
  classNameItem,
  classNameActiveItem,
  disabled,
}: ISegmentedControlProps) {
  return (
    <div className={clsx(styles.root, fullWidth ? styles.full : '', className)}>
      {options.map((item: ISegmentedControlOption, index: number) => (
        <button
          key={item.value}
          type="button"
          className={clsx(
            classNameItem,
            value === item.value ? classNameActiveItem : '',
            index === 0 ? styles.first : '',
            index === options.length - 1 ? styles.last : '',
          )}
          onClick={() => onChange(item.value)}
          disabled={disabled}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}

export default SegmentedControl;
